<template>
  <div class="panel-body main-content row">
    <div class="contentLeft">
      <div class="top_content">
        <div id="service">
          <div class="toptitle">
            <h1>pluscommサービス利用規約</h1>
          </div>
          <div class="section">
            <h2>第01条 総則</h2>
            <ul class="decimal">
              <li class="num01">pluscommサービス利用規約（以下「本規約」という。）は、アクロスウェイ株式会社（以下、「当社」という。）が提供する 第02条1項に定める pluscomm サービスを利用するにあたり、サービス利用者に適用される条件を定めることを目的としています。またpluscommサービスの利用開始をもって本規約に同意したものとします。</li>
              <li class="num02">本規約は、pluscommサービスを利用する全ての利用者に効力があり、本規約を廃止又は利用者がpluscommサービスを解約するまで事実上維持され、法的な拘束力を持つことになります。</li>
            </ul>

            <h2>第02条 用語の定義</h2>
            <p>本規約における用語の定義は以下の通りとします。</p>
            <ul class="decimal">
              <li class="num01">「pluscomm サービス」（以下「本サービス」という）とは、インバウンドコール及びアウトバウンドコール等のクラウド電話サービス、SMS配信サービス、通話アプリケーションを開発するためのAPI提供サービス、及びアプリケーション開発に必要なドキュメントの提供サービスのことを言います。</li>
              <li class="num02">「テレスタックス社」とは、米国テキサス州オースティンに本社を置く TeleStax Inc. を言います。当社は、テレスタックス社と本サービスを提供するために必要なライセンス契約を締結しています。</li>
              <li class="num03">「プラットフォーム」（以下、「本プラットフォーム」という。）とは、利用者に本サービスを提供するために当社が構築する設備等のことを言います。</li>
              <li class="num04">「pluscomm API」とは、利用者が本プラットフォームを介してアプリケーション開発のために提供するAPI（アプリケーションプログラミングインタフェース）を言います。</li>
              <li class="num05">「利用者」とは、当社が本サービスを提供する企業及び個人のことを言います。</li>
              <li class="num06">「TTS（テキスト・トゥ・スピーチ）」とは、当社が利用者に提供するテキストを音声合成で読み上げる機能（本サービスに含む）のことを言います。</li>
            </ul>

            <h2>第03条 本サービスの申込条件</h2>
            <p>本サービスの申し込みするにあたり、以下を全て満たしていることが条件となります。</p>
            <ul class="decimal">
              <li class="num01">日本国の法令の影響下にある法人又は個人であること。</li>
              <li class="num02">本規約を事前に確認し同意していること。</li>
              <li class="num03">当社が指定する方法により決済登録が完了していること。</li>
              <li class="num04">過去5年以内に第8条2項に定める「解約」の実績がないこと。</li>
            </ul>

            <h2>第04条 本サービスの利用</h2>
            <ul class="decimal">
              <li class="num01">本サービスは、当社所定の申込用紙の提出により申し込みができ、それを当社所定の方法で承諾の通知を発信した場合に利用を開始することができます。</li>
              <li class="num02">利用者は、本サービスの利用につき、本規約及び個人情報保護方針について違反とならない範囲において、利用者が、利用者の顧客に提供するサービスを含めた利用ができるものとします。</li>
              <li class="num03">利用者は、当社が利用者に提供するアカウントが、排他的、譲渡不能、サブライセンス不可であり、当社の知的財産権の範囲内で本サービスを利用することになります。</li>
              <li class="num04">利用者は、本プラットフォーム上で利用者又は利用者の顧客が利用することを目的としたアプリケーション開発のための pluscomm API、クラウド電話サービス、及びSMS配信サービス等の本サービスを利用できるものとします。</li>
              <li class="num05">利用者は、本サービス利用中及び利用後に利用者のコンテンツ及びアプリケーションから発せられる全ての情報が利用者に責任を有し、利用者のアカウント情報、コンテンツ及びアプリケーションに含まれる認証キーやセキュリティ情報等について、適切に保護しなければならない責務が生じることを承諾するものとします。</li>
              <li class="num06">利用者のコンテンツ及びアプリケーションの開発、維持、管理は利用者の負担で対応するものとします。</li>
              <li class="num07">利用者は、利用者が本サービス内へ持ち込むプログラム、文書、画像、音声、音楽、データ等のコンテンツに対して、著作権、肖像権、意匠権、商標権等の権利を保持されると同時に、それらの利用に関わる全ての責任を負担するものとします。</li>
              <li class="num08">当社は、本サービスの利用に関するソフトウェア類、データ、コンテンツ、及びドキュメント等を利用者が随時利用できるようにします。利用者は、本規約への承諾を条件として、当社の知的財産権もしくは資産を当社所有の下で、各種の設定及びコピーを行えるものとします。</li>
              <li class="num09">利用者の個人情報を含むアプリケーション及びデータ等の当社の取り扱いについては当社の個人情報保護方針に準じます。</li>
              <li class="num10">利用者は、SMS配信サービスをご利用になる場合は、「pluscomm サービス及びＳＭＳサービス利用申込書 兼 利用契約/別紙１<a href="https://pluscomm.jp/sms_service.php">携帯電話会社が定めるSMS利用規則</a>」に同意するものとします。</li>
            </ul>

            <h2>第05条 本サービスの品質</h2>
            <p>本サービスの提供品質はベストエフォート型とし、実際の通信速度や通信品質を保証するものではありません。但し、当社は本サービスの品質向上に最善を尽くすと同時に、品質基準を満たしてないと判断した場合は、利用者と協議の上、対応策を講じていきます。</p>

            <h2>第06条 利用料金</h2>
            <ul class="decimal">
              <li class="num01">利用者は、本サービスの料金を原則としてクレジットカードにより支払うものとします。</li>
              <li class="num02">利用者が利用料金を延滞した場合は、支払期日の翌日から支払日までの日数に応じ、当社は年利14.6%の遅延損害金を利用者に請求することができます。但し、閏年であっても１年を365日で起算し遅延損害金を算出するものとします。</li>
              <li class="num03">利用料金の支払いの際に発生する手数料等は、原則として利用者が負担するものとします。</li>
              <li class="num04">利用者は、電話番号を利用する際は電話番号あたり所定金額のユニバーサルサービス料を別途支払うものとします。</li>
            </ul>
            <h2>第07条 本サービスの停止</h2>
            <ul class="decimal">
              <li class="num01">利用者が以下に該当する場合は、当社は事前の通知なく利用者のサービスを停止する場合があります。
                <ul class="sub_dec">
                  <li>(ア) 当社所定の方法で申し込みをされ、当社が承諾の通知を発信し、本サービスが利用できる環境にあるにも関わらず180日間サービスの利用がない場合</li>
                  <li>(イ) 利用料金を30日間滞納した場合</li>
                  <li>(ウ) 利用者が使用するアプリケーションが他の利用者又は第三者に対し継続的に負荷を与えていると当社が判断した場合</li>
                  <li>(エ) 第三者への侵害行為の疑いがある場合</li>
                  <li>(オ) 法的、法規的事由により停止することが妥当と考えられる場合</li>
                </ul>
              </li>
              <li class="num02">以下の場合は、当社は事前の通知なく本サービスを停止する場合があります。
                <ul class="sub_dec">
                  <li>(ア) 第三者から攻撃を受けるなどの事態が発生した場合</li>
                  <li>(イ) 法的、法規的事由により停止することが妥当と考えられる場合</li>
                </ul>
              </li>
            </ul>

            <h2>第08条 本サービスの解約</h2>
            <ul class="decimal">
              <li class="num01">利用者が本サービスを解約する場合
                <ul class="sub_dec">
                  <li>(ア) 利用者は、当社に解約する旨を書面、若しくは電子メールで通知することにより解約することができます。</li>
                  <li>(イ) 解約月日は、原則、該当月の翌月末日、若しくはそれ以降の月末日となります。</li>
                  <li>(ウ) 当社は、利用者からの解約通知を受け取り次第、解約手続きを終了させ、その旨を電子メール、若しくは書面で連絡することにより解約が成立します。</li>
                </ul>
              </li>
              <li class="num02">利用者が以下項目に該当するために本サービスを解約する場合
                <ul class="sub_dec">
                  <li>(ア) 利用者が本規約へ違反した場合、又は本規約への違反行為があると認められるに正当な理由がある場合</li>
                  <li>(イ) 本サービスに悪影響を与える程の異常な負荷の増加、又は利用者のサービスが詐欺行為に加担していると認められる正当な理由がある場合</li>
                  <li>(ウ) 当社が利用者に提供するあらゆるサービスが準拠法又は法的、法規上の理由により非現実的又は非実用的となりうる場合</li>
                  <li>(エ) 利用者が破産、民事再生、会社更生、又は特別再生開始の申し立てがあったとき、又はそれらと同様の状態に陥っている場合</li>
                  <li>(オ) 本サービスについての支払義務の不履行が認められる場合、又は無効な支払手段を提示している場合</li>
                </ul>
              </li>
            </ul>

            <h2>第09条 本サービスの停止及び解約後の処置</h2>
            <ul class="decimal">
              <li class="num01">本サービスの全体又は一部の利用を停止した場合の取り扱いついて、利用者は以下の各号に承諾の上、本サービスを継続利用するものとします。
                <ul class="sub_dec">
                  <li>(ア) システム障害、メンテナンス、瑕疵等により本サービスの利用が停止中であっても料金が生じ、利用者に支払義務が生じます。</li>
                  <li>(イ) 利用者は、本サービスが停止したために生じる利用者の損害（利用者が提供する顧客を含む）及びクレーム対応等の責任を負うことになります。</li>
                </ul>
              </li>
              <li class="num02">本サービスの全体又は一部の利用を解約した場合の取り扱いついて、利用者は以下の各号に承諾の上、本サービスを利用するものとします。
                <ul class="sub_dec">
                  <li>(ア) 解約日まで利用者に本規約の効力は生じます。</li>
                  <li>(イ) 解約日が過ぎた時をもって利用者の本サービスに関する権利を失います。</li>
                  <li>(ウ) 利用者は、本サービスの解約日までの利用料を負担します。但し、月の途中の場合、固定（月額）料金部分は日割り計算を行わず、解約月までの満額を負担するものとします。</li>
                </ul>
              </li>
            </ul>

            <h2>第10条 権利義務の譲渡の禁止</h2>
            <p>利用者は、本規約上の地位及び本規約から生じる権利義務を第三者に譲渡又は担保に供することはできません。</p>

            <h2>第11条 運用保守</h2>
            <p>本サービスを安全かつ円滑に運用するために、利用者は以下の運用保守に関する基本事項に承諾するものとします。</p>
            <ul class="decimal">
              <li class="num01">予期しない期間において、停電及びシステム障害等の事由により本サービスの一部又はすべてが停止し、利用者に提供できないことがあります。</li>
              <li class="num02">当社が定期的に実施するシステムのアップデート及び改修作業等により、本サービスを一時停止することがあります。</li>
              <li class="num03">当社は、本サービスの定期的なアップデートにより利用者へ提供する本プラットフォーム及びドキュメントを変更する場合があります。この変更により利用者のコンテンツ及びアプリケーションが動作しなくなった場合は、利用者は、変更後の仕様に合わせた追加、修正を、自己の負担で行うことになります。</li>
            </ul>

            <h2>第12条 知的所有権</h2>
            <ul class="decimal">
              <li class="num01">当社は次の権利及び利得（知的財産及び所有権）を全て留保するものとします。

                <ul class="sub_dec">
                  <li>(ア) 本サービス</li>
                  <li>(イ) 当社が提供する本プラットフォーム</li>
                  <li>(ウ) 当社が本サービスを通じて提供するアプリケーション、コンテンツ及び知的財産</li>
                  <li>(エ) オープンソースライセンスを除く、本サービスに関係するドキュメント、ツール、サービスの権利</li>
                </ul>
              </li>
              <li class="num02">本規約において権利と所有権が明確であるもの、及び当社及びテレスタックス社が所有するものを除き、次の知的財産の所有権は利用者に帰属します。

                <ul class="sub_dec">
                  <li>(ア) 利用者が本サービスを利用して作成したコンテンツ及びデータ</li>
                  <li>(イ) 利用者が本サービスを利用して作成したアプリケーション</li>
                  <li>(ウ) 当社が作成を代行し、利用者に引き渡したアプリケーション</li>
                </ul>
              </li>
              <li class="num03">利用者は、本サービス利用中及び解約後において、当社及びテレスタックス社に対し、特許及び知的財産権の侵害を申し立て、又は第三者にその権利を与え第三者をもって侵害を申し立てることはできません。</li>
              <li class="num04">利用者は、利用者が制作するコンテンツ及びアプリケーションの著作権及び権利の許諾又は放棄、譲渡等に関する情報を、自身のコンテンツ及びアプリケーションに明記することに同意します。</li>
            </ul>

            <h2>第13条 免責</h2>
            <p>当社は、理由の如何を問わず、利用者に対して次の各号の事由について賠償の責任を負わないものとします。</p>
            <ul class="decimal">
              <li class="num01">天災地変、騒乱、暴動等の不可抗力により生じた損害</li>
              <li class="num02">利用者が本プラットフォームにアップロードした自前のコンテンツ及びアプリケーション、データの監視・監督義務</li>
              <li class="num03">本サービスによる110番、119番などの緊急番号への接続</li>
              <li class="num04">利用者と第三者との間で生じた紛争</li>
              <li class="num05">利用者と利用者のサービス提供先との間に生じた損害</li>
              <li class="num06">利用者が本プラットフォームにアップロードした機密情報及び個人情報の漏洩による損害</li>
              <li class="num07">利用者が本プラットフォームにアップロードしたデータの破壊、改ざん、滅失によって生じた損害</li>
              <li class="num08">当社が提供していない製品及び設備、又はプログラムの利用により生じた損害（OS、ミドルウェア、データベース、連携システム、外部サーバ等）</li>
              <li class="num09">第7条に定める「停止」により生じた損害</li>
              <li class="num10">第8条2項に定める「解約」により生じた損害</li>
              <li class="num11">第11条3項に定める利用者の対応の遅延により生じた損害</li>
              <li class="num12">本サービスの他の利用者の行為により生じた損害</li>
              <li class="num13">第三者の不正行為により生じた損害</li>
              <li class="num14">当社からプログラムのアップデートを利用者へ依頼したにも関わらず指定期日内に適切に   実施されなかった場合に生じた損害</li>
              <li class="num15">本プラットフォームのデータセンター設備及びネットワークが起因し生じた損害</li>
              <li class="num16">利用者側の設備及びネットワークが起因し生じた損害</li>
              <li class="num17">サイバー攻撃、ハッキング及びウィルス感染などにより生じた損害</li>
              <li class="num18">電話回線の輻輳及びネットワークトラフィックの高負荷が起因し生じた損害</li>
            </ul>

            <h2>第14条 本サービスの利用制限</h2>
            <p>利用者は、本サービスの利用につき次の各項を遵守することに承諾するものとします。</p>
            <ul class="decimal">
              <li class="num01">本サービスを第三者と共有利用しないこと</li>
              <li class="num02">本サービスを利用するためのID・パスワードをみだりに第三者に公開しないこと</li>
              <li class="num03">他人になりすまして本サービスを利用しないこと</li>
              <li class="num04">利用者の本サービスへの登録情報が正確かつ完全であること</li>
              <li class="num05">当社又は第三者のあらゆる権利への違反、濫用、侵害行為をしないこと</li>
              <li class="num06">プライバシー権、肖像権、名誉毀損、私的、又は公的権利への侵害行為をしないこと</li>
              <li class="num07">わいせつ、児童ポルノ又は児童虐待にあたるコンテンツを送信しないこと</li>
              <li class="num08">違法な活動への故意の使用、誹謗中傷、違法かつ個人又は全体に害をなす目的、人種、性別、宗教、国籍、障害、嗜好、年齢による差別に加担しないこと</li>
              <li class="num09">コンテンツ及びアプリケーションに有害なものを含めないこと</li>
              <li class="num10">利用者が提供する製品名、サービス名、イベント名などに本サービスの電話番号を含めないこと</li>
              <li class="num11">本サービスの第三者に対する複製、譲渡、開示、貸出、配布、修正、デコンパイル、逆アセンブル及びリバースエンジニアリング行為をしないこと</li>
              <li class="num12">第三者へ迷惑を掛けると当社が判断するスパム行為、いたずら等をしないこと</li>
              <li class="num13">コンピュータウィルス等の有害なプログラムを送信しないこと</li>
              <li class="num14">故意に他の利用者及び第三者の設備等に負荷をかけないこと</li>
              <li class="num15">違法賭博に利用しないこと</li>
              <li class="num16">広告、宣伝、勧誘に利用しないこと</li>
              <li class="num17">TTS（テキストトゥスピーチ）機能の合成音声を無断で録音し保存した音声データを再利用すること</li>
            </ul>

            <h2>第15条 反社会的勢力の排除</h2>
            <ul class="decimal">
              <li class="num01">利用者は、過去、現在および将来にわたり、反社会的勢力（暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者をいいます）に該当しないことを保証し、および暴力的行為、詐術・脅迫行為、業務妨害行為等、法令に抵触する行為またはそのおそれのある行為を行わないものとします。</li>
              <li class="num02">利用者が前項の規定に違反した場合には、当社は事前に通告することなく利用者の本サービス利用を停止し、または登録を削除する等の措置を講じることができるものとします。これにより利用者に何らの不利益または損害が生じたとしても、当社は一切の責任を負わないものとします。 </li>
            </ul>

            <h2>第16条 番号ポータビリティによる電話番号の譲渡</h2>
            <ul class="decimal">
              <li class="num01">利用者は、当社が事前審査により許諾した電話番号のみ、所定の申込用紙を提出することにより番号ポータビリティを申し込むことができます。</li>
              <li class="num02">利用者は、当該電話番号の所有権において、移動元電話会社から当社へ譲渡することに承諾するものとします。</li>
              <li class="num03">当社は、番号ポータビリティの申し込みを受理した電話番号において、利用者へ利用開始日を通知します。 ただし、この通知は当社が当該サービスの提供及び開始日を約束するものではなく、当社の裁量により通知を取り消す場合があります。</li>
              <li class="num04">当社は、番号ポータビリティを実施した電話番号において、利用者から解約や他の電話会社への名義変更の申し出があった際は、速やかに応じます。</li>
            </ul>

            <h2>第17条 補償</h2>
            <ul class="decimal">
              <li class="num01">利用者は、利用者のサービス提供先、又は他の利用者、又は第三者から次の各号の苦情、クレーム等により補償の必要が生じた場合、当社及び他のライセンサー、ビジネスパートナー及びその従業員等を含む全ての関係者に害を与えないように、当該事項についての全てのクレームに関連する消失、損害、責任、判決、罰金、その他費用についての補償と処理を行うものとします。
                <ul class="sub_dec">
                  <li>(ア) 利用者のサービスが、当社の所有資産を含んでいる場合、又は本規約により認可されていない、又は準拠法に違反している場合</li>
                  <li>(イ) 利用者のコンテンツ及びアプリケーション、又は他のアプリケーションと連携しているコンテンツ及びプロセスが特許の侵害に関与しているか、又は第三者の権利（画像、意匠、製品、広告、宣伝）の侵害又は濫用が認められる場合</li>
                  <li>(ウ) 本規約に記載された規程に限らず、追加の指針等でも違反がある場合</li>
                  <li>(エ) 利用者又は利用者が法人又は団体の場合は従業員に個人的な過失が認められる場合</li>
                </ul>
              </li>
              <li class="num02">当社は前項のクレームによる補償対象となる利用者に対して速やかに告知を行います。
                万が一、当社の告知が不十分であり、それにより利用者の対応への遅延又は不利益があるとしても、本規約に基づいて要求される利用者の責務に影響を与えません。</li>
            </ul>

            <h2>第18条 利用者の権利の継承</h2>
            <ul class="decimal">
              <li class="num01">利用者が法人又は団体の場合、本サービス利用期間中に合併その他地位の一部及び全部を継承する事由が生じた場合は、その地位を継承した法人又は団体は、特段の意思表示がない限り、当該利用者の地位を継承するものとします。</li>
              <li class="num02">前項の場合において、利用者の地位を継承した法人又は団体は、継承した時をもって本規約に同意したものとします。また、当社の定める方法により、延滞なく当社に届出事項の変更の申請を行うものとします。</li>
              <li class="num03">当社は、利用者が本条に定める届出を行わず、又は遅延したことにより生じた如何なる不利益又は損害に対しても一切責任を負わないものとします。</li>
            </ul>

            <h2>第19条 利用者データのバックアップ及び移動</h2>
            <p>利用者が作成するコンテンツ及びアプリケーション、又は本サービス内に持ち込む文書、画像、データ及び設定情報は、利用者が責任を持って管理及びバックアップするものとします。尚、それらのデータ及び設定情報において他サーバへの移動、再設定等が必要になる場合は利用者が行うものとします。</p>

            <h2>第20条 告知</h2>
            <ul class="decimal">
              <li class="num01">本規約に基づく利用者への告知は全て、利用者が登録時に記入したメールアドレスに対して電子メールにて送付されます。</li>
              <li class="num02">本サービスへの利用者の登録情報に更新がある場合は、速やかにその旨を当社に通知するものとします。</li>
              <li class="num03">メールアドレスの管理は個人情報保護方針により厳重に管理されます。尚、当社は利用者によるメールアドレスの誤記入、もしくは更新の非通知、不備等により、当社からの告知を受け取れない場合に発生した損害の責任も、当社は負担しないものとします。</li>
              <li class="num04">本規約又は個人情報保護方針に関する質問は、<br />
                <a href="https://www.acrossway.com/contact/" target="_blank">https://www.acrossway.com/contact/</a> より行ってください。
              </li>
            </ul>

            <h2>第21条 本サービス料金の変更</h2>
            <p>当社は、本サービスにおける利用料金の一部又は全てを変更する場合があります。尚、料金変更は当社ウェブサイト（<a href="https://pluscomm.jp/">https://pluscomm.jp/</a>）にて利用者へ事前告知し、サービス継続利用中の利用者に対しても該当月から変更後の料金を適用します。</p>

            <h2>第22条 規約の変更</h2>
            <p>本規約は、利用者への事前の告知なく当社の事情により変更することがあります。この場合、変更後の規約は当社ウェブサイトに掲載され、公開された時をもって、利用者は変更後の規約に同意したとみなされます。尚、利用者は本規約の変更点を確認するために、利用者が当社ウェブサイトを定期的に確認していただくものとします。</p>

            <h2>第23条 準拠法</h2>
            <p>本規約は、日本法に準拠し、同法に従って解釈されるものとします。</p>

            <h2>第24条 合意管轄</h2>
            <p>本規約に関して訴訟上の紛争が生じた場合は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>

            <h2>第25条 完全合意</h2>
            <p>本規約は、以後の変更内容を含め、本サービスにおける全ての指針及び指標を利用者と当社の間で合意した承認事項を記載しているものであり、本規約の公開以前及び以降にかかわらず利用者と当社従業員（パート及びアルバイト、派遣社員を含む）との間において、口頭により本規約の条項に関わる内容の同意がなされていた場合はそれを無効とし、当該本規約を優先するものとします。</p>

            <h2>第26条 当規約の制定及び改定</h2>
            <p>本規約制定日： 2018年6月30日</p>
            <p>本規約改定日： 2020年3月23日</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'account_index',
  components:{
  }
}
</script>

<style>
  .section li {
    text-indent:-3.4rem;
    padding-left: 1.2rem !important;
  }
  .section li:before {
    margin-right: 5px;
    display:inline-block;
    width:3.5em;
    text-align:right;
  }
  .section li.num01:before {
    content: "１.";
  }
  .section li.num02:before {
    content: "２.";
  }
  .section li.num03:before {
    content: "３.";
  }
  .section li.num04:before {
    content: "４.";
  }
  .section li.num05:before {
    content: "５.";
  }
  .section li.num06:before {
    content: "６.";
  }
  .section li.num07:before {
    content: "７.";
  }
  .section li.num08:before {
    content: "８.";
  }
  .section li.num09:before {
    content: "９.";
  }
  .section li.num10:before {
    content: "１０.";
  }
  .section li.num11:before {
    content: "１１.";
  }
  .section li.num12:before {
    content: "１２.";
  }
  .section li.num13:before {
    content: "１３.";
  }
  .section li.num14:before {
    content: "１４.";
  }
  .section li.num15:before {
    content: "１５.";
  }
  .section li.num16:before {
    content: "１６.";
  }
  .section li.num17:before {
    content: "１７.";
  }
  .section li.num18:before {
    content: "１８.";
  }
  .section li > ul li {
    text-indent:-4.6rem;
    padding-left:1.2rem !important;
  }
  .section li > ul li:before {
    content: "  ";
    font-size: 12px;
  }
  .section h2 {
    display: inline-block;
    margin-top: 30px;
    font-size: 22px!important;
    color: #002950;
  }
  .section .decimal{
    padding-left:1em;
  }
  .section .sub_dec{
    padding-left:0;
    padding-top:0.5rem;
  }
  .contentLeft .section p{text-indent:1em;}
  @media screen and (max-width: 767px){
    .section .decimal {
      padding-left: 20px;
    }
    .section .sub_dec {
      padding-left: 0px;
      padding-top:0.5rem;
    }
    .section li > ul li {
      text-indent:-4.6rem;
      padding-left:1.2rem !important;
    }
  }
</style>